import { BASE_URL } from "../../../../Utilities/APIs/APIs"

function Image({imgLink, imgAlt}) {
  return (
    <img src={BASE_URL + imgLink} alt={imgAlt} />
  )
}

export default Image